var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aa-privacy-policy"},[_c('v-container',[_c('div',{staticClass:"aa-privacy-policy__wrap"},[_c('h1',[_vm._v("Privacy Policy")]),(this.field)?_c('div',{domProps:{"innerHTML":_vm._s(this.field.content)}}):_vm._e()])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }